<div class="nr-answer-container" #container (focus)="onFocus()" (mouseover)="hovered = true" (mouseout)="hovered = false" tabindex="0" [ngClass]="{'focused': focused, 'nr-hover': hovered}"></div>
